import { createContext, useContext, useState, useCallback } from "react";

type RecordingContextType = {
  isRecordingActive: boolean;
  setRecordingActive: (active: boolean) => void;
};

const RecordingContext = createContext<RecordingContextType>({
  isRecordingActive: false,
  setRecordingActive: () => {},
});

export function RecordingProvider({ children }: { children: React.ReactNode }) {
  const [isRecordingActive, setIsRecordingActive] = useState(false);

  const setRecordingActive = useCallback((active: boolean) => {
    setIsRecordingActive(active);
  }, []);

  return (
    <RecordingContext.Provider value={{ isRecordingActive, setRecordingActive }}>
      {children}
    </RecordingContext.Provider>
  );
}

export function useRecordingStatus() {
  return useContext(RecordingContext);
}
